<template>
  <div class="d-flex align-center">
    <!-- Avatar with Image or Camera Icon -->
    <v-avatar size="36" @click="triggerUpload">
      <img v-if="preview" :src="preview" alt="Profile Photo" />
      <v-btn v-else icon>
        <v-icon>mdi-camera</v-icon>
      </v-btn>
      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        class="d-none"
        @change="handleFileChange"
      />
    </v-avatar>

    <!-- File Name (Truncated to 80px) -->
    <span
      v-if="errorUpload"
      class="ml-2 error--text truncate"
      style="max-width: 110px"
    >
      Upload Image
    </span>
    <span
      v-if="fileName"
      class="ml-2 text-caption truncate"
      style="max-width: 110px"
    >
      {{ fileName }}
    </span>
  </div>
</template>

<script>
export default {
  props: ["value", "errorUpload"],
  data() {
    return {
      preview: null,
      fileName: null,
    };
  },
  created() {
    console.log(this.errorUpload);
  },
  methods: {
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileName = file.name;
        const reader = new FileReader();
        reader.onload = (e) => (this.preview = e.target.result);
        reader.readAsDataURL(file);
        this.$emit("input", file);
      }
    },
  },
};
</script>

<style scoped>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
